import angular from 'angular';

angular.module('app.services')

    .factory('LoginService', ['$q', 'LoginFactory', function($q, LoginFactory) {
        var service = {};

        service.authenticateUser = function() {

        };
    }])

    .factory('LoginFactory', function($resource, AppConfig) {
        var factory = {};

        factory.authenticate = function() {
            return $resource(AppConfig.IO_API_URL + 'login')
        };

    });
